import type { PlatformOverride } from '../types';

export const sizzlecpgOverrides: PlatformOverride = {
  "industry": "CPG",
  'home.hero.headerText': 'the USA 🇺🇸',
  'home.hero.country': 'US',
  'home.hero.countryShort': 'the USA',
  'footer.email': 'hi@sizzlecpg.com',
  'footer.linkedinUrl': 'https://linkedin.com/company/sizzlecpg',
  'footer.skimlinksFileId': '300256X1788095',
  'about.pageTitle': 'About Sizzle | Discovering the Best of US CPG',
  'about.metaDescription':
    "Learn more about Sizzle, our mission to showcase America's most exciting CPG brands.",
};
